import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { convertSecondsToTime } from 'utils/timeHelper';
import { Routes } from 'router/routes';

const ActivityRow = ({ rowItem, date }) => {
  const timeSpent = (type) => {
    let value;
    const time = rowItem.totalActionTime
      ? parseInt(rowItem.totalActionTime)
      : 0;
    switch (type) {
      case 20:
        value = time >= 1200 ? 'Y: ' : 'No: ';
        break;
      case 40:
        value = time >= 2400 ? 'Y: ' : 'No: ';
        break;
      case 60:
        value = time >= 3600 ? 'Y: ' : 'No: ';
        break;
      case 'total':
        value = `${convertSecondsToTime(time)} `;
        break;
      default:
        break;
    }
    value += date;
    return value;
  };
  return (
    <tr className="activity-row">
      <td data-label="Patient Guid">{rowItem.patient.guid}</td>
      <td data-label="Insurance Number">{rowItem.insurances[0]?.number}</td>
      <td data-label="Patient Name">
        <Link to={Routes.patientGuid(rowItem.patient.guid)}>
          <strong>
            {rowItem.patient.title} {rowItem.patient.fullName}
          </strong>
        </Link>
      </td>
      <td data-label="DOB">{rowItem.patient.birthDate}</td>
      <td data-label="MRN">{rowItem.patient.mrn}</td>
      <td data-label="ICD-10 Codes">
        <div className="billing-table-icd-code-col">
          {rowItem.patient.icdCodes}
        </div>
      </td>
      <td data-label="CPT 99490 20 min">{timeSpent(20)}</td>
      <td data-label="CPT 99439 40 min">{timeSpent(40)}</td>
      <td data-label="CPT 99439 60 min">{timeSpent(60)}</td>
      <td data-label="Time Spent">{timeSpent('total')}</td>
    </tr>
  );
};
ActivityRow.propTypes = {
  rowItem: PropTypes.shape().isRequired,
  date: PropTypes.string.isRequired,
};

export default ActivityRow;
